import { materializePackage } from './sectionLibrary';

// Reuse authored semantic chrome, not tenant names, labels or CSS class guesses.
export const chromeKind = section => {
  const root = section?.root;
  if (root?.type !== 'element') return null;
  if (root.tag === 'header' || root.attrs?.role === 'banner') return 'header';
  if (root.tag === 'footer' || root.attrs?.role === 'contentinfo') return 'footer';
  return null;
};

export function hasWebsiteChrome(website) {
  if (!website || website.package?.native) return false;
  const pkg = materializePackage(website.package, website.edits);
  const page = pkg.pages[pkg.manifest.entry];
  const rows = website.edits.sections[pkg.manifest.entry] || page.sections;
  return rows.some(row => row.enabled && chromeKind(page.sections.find(s => s.id === row.id)) === 'header');
}

// Read the published design's actual base styling, including uploaded CSS fonts.
// Slotted native content keeps global app CSS without importing it into the theme.
export function websiteContentTheme(style) {
  return {
    ...(style.fontFamily ? { headingStack: style.fontFamily, bodyStack: style.fontFamily } : {}),
    ...(style.color ? { ink: style.color } : {}),
    ...(style.backgroundColor && !['transparent', 'rgba(0, 0, 0, 0)'].includes(style.backgroundColor)
      ? { paper: style.backgroundColor } : {}),
  };
}
